import { get, del, postFile } from 'lib/API';
import Media from 'data/Media';
import { UploadOptionsImage, UploadOptions, MediaImage } from 'data/Media';
import { sanitizeFilename } from 'utils/string';

export const deleteMedia = async (id: number, path: string, token: string) => {
  const params = new URLSearchParams();
  params.append('path', path);
  return await del(`v1/media/${id}?${params.toString()}`, token);
};

export async function postMedia(args: UploadOptionsImage & { vendorId?: number }): Promise<MediaImage>;
export async function postMedia(args: UploadOptions & { vendorId?: number }): Promise<Media>;
export async function postMedia({ file, filename, token, type, vendorId }: UploadOptions & { vendorId?: number }): Promise<Media> {
  const params = new URLSearchParams();

  const sanitizedFilename = filename && filename.trim() !== '' ? sanitizeFilename(filename) : "";
  params.append('name', sanitizedFilename);
  params.append('type', type);
  vendorId && vendorId !== 0 ? params.append('vendorId', vendorId.toString()) : "";
  const mediaUrl = `v1/media?${params.toString()}`;
  return await postFile(mediaUrl, file, token);
};

export const getMedia = async ([mediaId]: any, { token }: any): Promise<Media> => {
  return await get(`v1/media/${mediaId}`, token);
};
